import styled from 'styled-components';

export const Select = styled.select`
appearance: none;
padding-left: 6px;
background-color: #FB563E;
width: 50%;
height: 45px;
display: flex;
justify-content: center;
margin: auto;
border: none;
border-radius: 3px;
color: #1C0825;
font-family: "Questrial";
font-weight: bold;
font-size: 1em;
cursor: pointer;
margin-bottom: -10px;
outline: none;

@media (min-width: 1024px){
    width: 15%;
}
`